jQuery(document).ready(function($){
	setTimeout(()=>{
      $('.pplr-wrapper img').each(function() {
          var imageDataSource = $(this).attr('data-src');
          $(this).attr('src', imageDataSource);
      });
     
	},3000);
  setTimeout(()=>{
     $('.pplr-wrapper:first-child').addClass('pplr-collapsible');
    },1000);
});
